import SideBarLink from 'components/atoms/sidebar/SideBarLink';
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Button, Modal } from 'semantic-ui-react';
import { Field, Form, reduxForm } from 'redux-form';
import FormSectionHeading from 'components/atoms/form/FormSectionHeading';
import { connect } from 'react-redux';
import { get } from 'lodash';
import StarScale from 'components/molecules/StarScale';
import TextAreaAdmin from 'components/atoms/inputs/TextAreaAdmin';
import { hideFeedbackModal, logUserFeedback, showFeedbackModal } from 'services/feedback/duck';
import { closeMobileNav } from 'services/layout/duck';
import styled from 'styled-components';
import ProtectedComponent from 'hoc/ProtectedComponent';
import { FEEDBACK_CREATE } from 'constants/capabilities';

const Footer = styled(Modal.Actions)`
    @media (max-width: 767px) {
        margin: 14px;
    }
`;

const FEEDBACK_FORM = 'userFeedbackForm';

const UserFeedback = ({ feedbackModal, closeNav, handleSubmit, openModal, closeModal }) => {
    useEffect(() => {
        if (feedbackModal) {
            openModal();
        } else {
            closeModal();
        }
    }, [feedbackModal]);

    return (
        <React.Fragment>
            <li key={'feedback'}>
                <SideBarLink
                    linkName={'Feedback'}
                    icon={'comment icon'}
                    clickAction={ () => {
                        openModal();
                        closeNav();
                    }}
                />
            </li>
            <Modal
                dimmer={{ style: { zIndex: 10001 } }}
                closeIcon={{ style: { top: 10, right: 10 }, color: 'black', name: 'close' }}
                style={{
                    position: 'relative',
                    borderRadius: 15,
                    maxWidth: 300
                }}
                size={'mini'}
                onClose={closeModal}
                onOpen={openModal}
                open={feedbackModal}
            >
                <Modal.Header style={{ height: 48 }}/>
                <Modal.Content style={{ padding: 16 }}>
                    <Form
                        onSubmit={handleSubmit(logUserFeedback)}
                        id={FEEDBACK_FORM}
                    >
                        <FormSectionHeading textTransform={'initial'} style={{ marginTop: 0, marginBottom: 6 }}>
                            How are we doing?
                        </FormSectionHeading>
                        <Field
                            name={'feedbackRating'}
                            component={StarScale}
                            label={'How was your experience'}
                        />
                        <FormSectionHeading textTransform={'initial'} style={{ marginTop: 0, marginBottom: 6 }}>
                            How can we improve?
                        </FormSectionHeading>
                        <Field
                            name={'feedbackDescription'}
                            component={props => (
                                <TextAreaAdmin
                                    maxLength={255}
                                    resize={{
                                        vertical: { min: 240, max: 480 },
                                        horizontal: { allowResize: false }
                                    }}
                                    {...props}
                                />)
                            }
                            label={'Any additional feedback?'}
                            required={false}
                        />
                    </Form>
                </Modal.Content>
                <Footer>
                    <Button primary form={FEEDBACK_FORM} type="submit">
                        Submit
                    </Button>
                </Footer>
            </Modal>
        </React.Fragment>

    );
};

UserFeedback.propTypes = {
    feedbackModal: PropTypes.bool,
    closeNav: PropTypes.func,
    openModal: PropTypes.func,
    hideModal: PropTypes.func,
    handleSubmit: PropTypes.func,
};

const ProtectedUserFeedback = ProtectedComponent({
    requiredCapabilities: [FEEDBACK_CREATE],
    alwaysRender: false,
})(props => <UserFeedback {...props} />);

const mapStateToProps = state => ({
    feedbackModal: get(state, 'feedback.feedbackModal', false)
});

export default connect(mapStateToProps, {
    closeNav: closeMobileNav,
    openModal: showFeedbackModal,
    closeModal: hideFeedbackModal
})(reduxForm({
    form: FEEDBACK_FORM,
})(ProtectedUserFeedback));



// WEBPACK FOOTER //
// ./src/components/organisms/UserFeedback.js